var lib_core = require("lib-core");

if(typeof window !== 'undefined'){
    var ui_extensions = require("ui-extensions");
}

var EcadioModelSelectorTrayModel = require('./ecadioModelSelectorTrayModel.js');
var EcadioModelSelectorTrayView = require('./ecadioModelSelectorTrayView.js');
var EcadioModelSelectorTrayStateMachine = require('./ecadioModelSelectorTrayStateMachine.js');
var PackageController = require('./../footprint3dViewer/packageFootprintViewerController.js')
var ModelUploadController  = require('../modelUploader/modelUploadController.js');
var Editor3d = require("editor-3d-light").Editor3dController;
var ProcessMessageController = ui_extensions.ProcessMessageController;

var EcadioModelSelectorTrayController = function(archLayers, dependencies, configuration) {
    ui_extensions.TrayAssetSearchTabController.call(this, archLayers, dependencies, configuration);


    lib_core.GuiEvents.addEvents({
        ECADIO_RESULT_SELECTED: {id: 'ui_ecadio_result_selected_01', name: "ECADIO_RESULT_SELECTED"}
    });

};

lib_core.inherit(EcadioModelSelectorTrayController, ui_extensions.TrayAssetSearchTabController);
module.exports = EcadioModelSelectorTrayController;
EcadioModelSelectorTrayController.inject = ui_extensions.TrayAssetSearchTabController.inject;
EcadioModelSelectorTrayController.inject.packageController = PackageController;
EcadioModelSelectorTrayController.inject.modelUploadController = ModelUploadController;
EcadioModelSelectorTrayController.inject.processMessageController = ProcessMessageController;
EcadioModelSelectorTrayController.inject.editor3d = Editor3d;

EcadioModelSelectorTrayController.prototype.createModel = function () {
     return new EcadioModelSelectorTrayModel(this.rootStateMachine, this.root.dataLoader, this.packageController.getModel());
};

EcadioModelSelectorTrayController.prototype.createView = function () {
    return new EcadioModelSelectorTrayView(this.root, this.getModel(), this.getStatemachine(), this.rootStateMachine, this.trayTabsController.getView(), this.trayTabsController.name(), this.configuration);
};

EcadioModelSelectorTrayController.prototype.createStateMachine = function () {
    var editor3dModel = this.editor3d.getModel();
    var modelUploadSM = this.modelUploadController.getStatemachine();
    var loadingModel = this.processMessageController.getModel();

    var parentName = this.trayTabsController.name();

    return new EcadioModelSelectorTrayStateMachine(this.root, this.getModel(), editor3dModel, modelUploadSM, loadingModel, parentName);
};